(function() {

    var module = angular.module('app');

    module.directive(
        'admin',
        function() {
            return {
                restrict: 'E',
                templateUrl: '/app/features/admin/admin.tpl.html',
                scope: {},
                controller: 'adminCtrl',
                controllerAs: 'vm',
                bindToController: true
            };
        });

    module.controller(
        'adminCtrl',
        function (adminService, loading, ModalService, $http) {
            var vm = this;

            (function activate() {
                vm.tracker = loading.createTracker();

                    vm.tracker.track(
                        loadWines()
                );
            }());

            vm.add = function() {
                ModalService.showModal({
                        templateUrl: '/app/features/admin/addEditWine.tpl.html',
                        controller: 'addEditWineController',
                        controllerAs: 'vm',
                        inputs: {
                            wine: { myCellarId: vm.selectedAccount.id}
                        }
                    })
                    .then(function(modal) {
                        modal.close.then(loadWines);
                    });
            }

            vm.edit = function(wine) {
                ModalService.showModal({
                        templateUrl: '/app/features/admin/addEditWine.tpl.html',
                        controller: 'addEditWineController',
                        controllerAs: 'vm',
                        inputs: {
                            wine: angular.copy(wine)
                        }
                    })
                    .then(function(modal) {
                        modal.close.then(loadWines);
                    });
            };

            vm.delete = function (wine) {
                vm.tracker.track($http.delete('/api/admin/wine/' + wine.id).then(function() {
                    toastr.success('Wine deleted');
                    return loadWines();
                }));
            }
            
            function loadWines() {
                return adminService.getAccounts()
                    .then(function(accounts) {
                        for (var i = 0; i < accounts.length; i++) {
                            for (var j = 0; j < accounts[i].wine.length; j++) {
                                accounts[i].wine[j].isEditMode = false;
                            }
                        }
                        vm.accounts = accounts;
                        vm.selectedAccount = vm.accounts[0];
                    });
            }
        }
    );
}());